module.exports = __webpack_public_path__ + "img/1.8c2db0be.png";